import { StorageDAO } from '../DAO/StorageDAO';
import { AppSingletonUtil } from '../Util/AppSingletonUtil';
import { toCamel } from '../Util/SnakeCamelUtil';
import { UserDAO } from '../DAO/UserDAO';
import { BaseService } from './BaseService';
import {UserDTOInterface} from '../DTO/UserDTOInterface';

/**
 * UserService
 *
 * ログイン認証関係のロジックサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class UserService extends BaseService {

	/**
	 * getUserInfo
	 * ユーザー情報の取得
	 * @returns ユーザー情報
	 */
	public async getUserInfo() {

		if (!AppSingletonUtil.getToken()) {
			return;
		}

		// ログインを行い、トークンを取得してくる
		const userDao = new UserDAO(this as BaseService);
		const ret = await userDao.getUserInfo();
		const dist = toCamel(ret);

		this.log(dist);
		AppSingletonUtil.setUserInfo(dist);

		return dist;

	}


	/**
	 * saveAllUserInfo
	 * ユーザー情報を登録する
	 * @param data 保存するユーザー情報
	 * @param id
	 * @returns 登録したユーザー情報
	 */
	public async saveAllUserInfo(data: any, id: string) {
		this.log('----------AuthService saveAllUserInfo-----------');

		if (!id) {
			id = '999999999';
		}

		// ログインを行い、トークンを取得してくる
		const userDao = new UserDAO(this as BaseService);
		const ret = await userDao.saveUserInfo(data, id);
		const dist: any = toCamel(ret);

		// ユーザー情報登録時にトークンが生成されるので、保持する
		AppSingletonUtil.setToken(dist.t);
		const storageDao = new StorageDAO(this as BaseService);
		await storageDao.saveItem('t', dist.t);

		// シングルトンでユーザー情報保存
		AppSingletonUtil.setUserInfo(dist);

		this.log(dist);
		return dist;
	}

	/**
	 * saveUserMedicalInfo
	 * 診察券番号（カルテ番号）とクリニック情報の保存
	 * @param data 診察券番号（カルテ番号）、クリニック情報
	 */
	public async saveUserMedicalInfo(data: any) {
		// ログインを行い、トークンを取得してくる
		const userDao = new UserDAO(this as BaseService);
		const ret = await userDao.saveUserMedicalInfo(data);
		return toCamel(ret);
	}


	public async updateOnlineMedicalData(data: UserDTOInterface): Promise<UserDTOInterface> {
		this.log('UserService::updateOnlineMedicalData()');
		const userDao = new UserDAO(this as BaseService);
		const ret = await userDao.updateOnlineMedicalData(data);
		this.log(toCamel(ret));
		return toCamel(ret) as UserDTOInterface;
	}
	/**
	 * updateUserInfo
	 * ユーザー情報の更新
	 * @param data ユーザー情報
	 */
	public async updateUserInfo(data: any) {

		// ログインを行い、トークンを取得してくる
		const userDao = new UserDAO(this as BaseService);
		const ret = await userDao.updateUserInfo(data);
		return toCamel(ret);
	}

	/**
	 * getLineLinkStatus
	 * Lineとの連携状態を取得する
	 * @returns true: 連携済み/false: 未連携
	 */
	public async getLineLinkStatus() {
		const userDao = new UserDAO(this as BaseService);
		return await userDao.getLineLinkStatus();
	}

	/**
	 * unlinkLineLink
	 * ライン連携解除設定
	 */
	public async unlinkLineLink() {
		const userDao = new UserDAO(this as BaseService);
		return await userDao.unlinkLineLink();
	}

}
